import React from 'react';
import RadialChart from 'components/@common/Charts/RadialChart';
import { generateSeriesPercent, deriveValueFromSeries } from 'utilities/radial-chart-util';

interface LicenseChartProps {
  assignedCount: number;
  expiringSoonCount: number;
  totalCount: number;
  overageCount: number;
}

const LicenseChart: React.FC<LicenseChartProps> = ({
  assignedCount,
  expiringSoonCount,
  totalCount
}) => {
  const denominator = totalCount || 1;

  return (
    <RadialChart
      height="250"
      width="100%"
      series={[
        generateSeriesPercent(assignedCount, denominator),
        generateSeriesPercent(expiringSoonCount, denominator)
      ]}
      options={{
        // assignedCount, // Force re-render of chart. // todo
        legend: {
          show: false
        },
        colors: ['#33B9D2', '#B22F12'],
        labels: ['Assigned', 'Exp. Soon'],
        grid: {
          //padding: { top: 0, right: 0, bottom: 0, left: 0 }
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                show: true,
                offsetY: 16,
                fontSize: '12px',
                color: '#000'
              },
              total: {
                show: true,
                // offsetY: 16,
                fontSize: '12px',
                color: '#000',
                label: 'Assigned',
                fontWeight: 400,
                formatter: () => `${assignedCount}`
              },
              value: {
                show: true,
                offsetY: -16,
                fontSize: '24px',
                formatter: (val: number) => `${deriveValueFromSeries(+val, denominator)}`
              }
            }
          }
        }
      }}
    />
  );
};

export default LicenseChart;
